export const DEFAULT_NOTIFICATION_STATE: NotificationFeatureState = {
  notificationMessages: undefined,
  nextNotificationMessageId: 1,
};

export interface NotificationFeatureState {
  notificationMessages: NotificationMessage[] | undefined;
  nextNotificationMessageId: number;
}

export interface NotificationMessage {
  id: number;
  code: Code;
  severity: Severity;
  text: string | undefined;
  markdown: string | undefined;
  deleteAfterNextNavigation: boolean;
  deleteAfterNumberOfMilliseconds: number | undefined;
}

export enum Severity {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

// Should uniquely identify a single type of notification message.
// Multiple notifications with the same code can be published.
// This allows a consumer to delete all notifications of a given type without us
// exposing the internal id which is generated by the store.
export enum Code {
  // Error
  UNHANDLED_EXCEPTION = "UNHANDLED_EXCEPTION",
  BENEFICIARY_PAGE_PERCENTAGES_UNEQUAL_ONE_HUNDRED = "BENEFICIARY_PAGE_PERCENTAGES_UNEQUAL_ONE_HUNDRED",
  RESET_INSURANCE_TERM_IN_YEARS = "RESET_INSURANCE_TERM_IN_YEARS",
  HAS_UNDERWRITING_QUESTIONS_PASSED_BEEN_RESET = "HAS_UNDERWRITING_QUESTIONS_BEEN_RESET",
  GENERAL_HTTP_PROBLEM = "GENERAL_HTTP_PROBLEM",
  OUTDATED_INSURANCE_START_DATE = "OUTDATED_INSURANCE_START_DATE",
  INSURED_SUM_HAS_CHANGED = "INSURED_SUM_HAS_CHANGED",
  INVALID_FILE = "INVALID_FILE",
  DOCUMENT_MANIPULATION_NO_DOCUMENTS = "DOCUMENT_MANIPULATION_NO_DOCUMENTS",
  // Success
  DOCUMENT_MANIPULATION_SUCCESS = "DOCUMENT_MANIPULATION_SUCCESS",
}
